import {
  Box,
  Checkbox,
  CloseIcon,
  Flex,
  FormSearchMultipleSelection,
  FormTimeInput,
  IconButton,
  MenuItem,
  type OptionSelectionProps,
  Text,
} from '@shared/components';

export interface ExamTimingByStructureCardProps {
  title: string;
  order: number;
  selection: {
    name: string;
    label: string;
    placeholder: string;
    options: OptionSelectionProps[];
    disabled?: boolean;
  };
  timeInput: {
    name: string;
    label: string;
    disabled?: boolean;
  };
  onDiscard?: (event: React.MouseEvent<HTMLElement>, order: number) => void;
}

export default function ExamTimingByStructureCard(props: Readonly<ExamTimingByStructureCardProps>) {
  const { title, order, selection, timeInput, onDiscard } = props;

  return (
    <Flex
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.rounded(1.5),
        backgroundColor: theme.palette.grey[50],
        flexDirection: 'column',
        gap: theme.spacing(4),
        p: theme.spacing(4),
      })}
    >
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Text variant='body1Semibold'>{title}</Text>
        <IconButton
          onClick={(event) => {
            onDiscard?.(event, order);
          }}
          disabled={!onDiscard}
          sx={{ p: (theme) => theme.spacing(0) }}
        >
          <CloseIcon />
        </IconButton>
      </Flex>

      <FormSearchMultipleSelection
        {...selection}
        renderOption={({ key, ...props }, option, { selected }) => {
          return (
            <MenuItem
              key={key}
              {...props}
              value={option.value}
              sx={(theme) => ({
                mb: theme.spacing(1),
                '&:last-child': { mb: theme.spacing(0) },
                '&.MuiAutocomplete-option': {
                  p: theme.spacing(1.5, 2),
                },
              })}
            >
              <Flex sx={{ gap: (theme) => theme.spacing(2) }}>
                <Checkbox value={selected} sx={{ p: (theme) => theme.spacing(0) }} />
                {option.label}
              </Flex>
            </MenuItem>
          );
        }}
      />

      <Box sx={{ maxWidth: '240px' }}>
        <FormTimeInput {...timeInput} />
      </Box>
    </Flex>
  );
}
